import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Bonus, CachedBonus, CachedBonuses } from '../../../../../../types/bonus';
import { updateCachedReactions, updateSingleBonusReactions } from '../../../cache/mutators/bonus';
import { QueryKey } from '../../../hooks/types';

export const useReplaceBonus = () => {
	const queryClient = useQueryClient();

	return useCallback(
		(newBonus: Bonus) => {
			queryClient.setQueriesData<CachedBonuses>([QueryKey.BonusesInfinite], (cached) => updateCachedReactions(newBonus.id, newBonus.reactions, cached));
			queryClient.setQueryData<CachedBonus>([QueryKey.Bonus, newBonus.id], (cached) => updateSingleBonusReactions(newBonus.id, newBonus.reactions, cached));
		},
		[queryClient]
	);
};
